/**
 * Hierarchical category list with collapsible subcategories (accordion).
 * Targets the WC product categories widget rendered with "Show hierarchy" enabled.
 */

import { initResponsiveModal } from '../utils/responsive-modal'

const ROOT_SELECTOR = '.product-category-filters'
const SIDEBAR_SELECTOR = '.product-categories-sidebar'
const PARENT_SELECTOR = 'li.cat-parent'
const ACTIVE_PARENT_CLASSES = ['current-cat', 'current-cat-parent', 'current-cat-ancestor']

function buildToggleButton() {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'category-accordion-toggle'
    button.setAttribute('aria-expanded', 'false')
    button.setAttribute('aria-label', 'Visa underkategorier')
    button.innerHTML = `
        <svg class="category-accordion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 6 15 12 9 18"></polyline>
        </svg>
    `
    return button
}

function shouldStartExpanded(parentLi) {
    return ACTIVE_PARENT_CLASSES.some((cls) => parentLi.classList.contains(cls))
}

// Synligheten styrs av CSS (archive.css) via klasser på <li>, så att
// starttillståndet redan stämmer vid första renderingen och inget hoppar (CLS).
function setExpanded(button, parentLi, expanded) {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    parentLi.classList.toggle('is-expanded', expanded)
    parentLi.classList.toggle('is-collapsed', !expanded)
}

function initAccordion() {
    const root = document.querySelector(ROOT_SELECTOR)
    if (!root) return

    const parents = root.querySelectorAll(PARENT_SELECTOR)
    parents.forEach((parentLi) => {
        if (parentLi.dataset.accordionInit === 'true') return
        const childList = parentLi.querySelector(':scope > ul.children')
        if (!childList) return

        parentLi.dataset.accordionInit = 'true'
        parentLi.classList.add('has-accordion')

        const button = buildToggleButton()
        const link = parentLi.querySelector(':scope > a')
        if (link) {
            link.insertAdjacentElement('afterend', button)
        } else {
            parentLi.prepend(button)
        }

        button.setAttribute('aria-expanded', shouldStartExpanded(parentLi) ? 'true' : 'false')

        button.addEventListener('click', (e) => {
            e.preventDefault()
            const isExpanded = button.getAttribute('aria-expanded') === 'true'
            setExpanded(button, parentLi, !isExpanded)
        })
    })
}

document.addEventListener('DOMContentLoaded', initAccordion)

/**
 * Toggle the categories sidebar into a modal on mobile (< lg breakpoint).
 * Targets the sidebar wrapper (not the widget) so modal.js finds an inner <div>.
 * Delar logik med arkivfiltren via initResponsiveModal.
 */
function handleModalAttributesForCategories() {
    initResponsiveModal(SIDEBAR_SELECTOR, 'categories')
}

document.addEventListener('DOMContentLoaded', handleModalAttributesForCategories)
